<form #form="ngForm">
    <div class="app-grid">
        <app-segment-header title="performance.selectATemplateToUse"></app-segment-header>
        <mat-form-field class="columns-12" *ngIf="templates?.length">
            <mat-select name="template" required #template_id="ngModel" [(ngModel)]="review.templateId">
                <mat-option *ngFor="let template of templates" [value]="template.id" [disabled]="!template.isValid">
                    {{ template.name }}
                    <ui-badge *ngIf="!template.isValid" class="right floated">{{
                        'performance.bulk-review.selectTemplate.incomplete' | translate | uppercase
                    }}</ui-badge>
                </mat-option>
            </mat-select>
            <mat-error *ngIf="template_id.invalid">{{ template_id.errors | formErrors }}</mat-error>
        </mat-form-field>
    </div>
</form>
